// Calls your Flask backend.
// Only implements login right now. Other endpoints still come from the mock.

import { authFetch } from "./http";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// Useful if you later add auto-refresh logic:
export function getAuthHeaders(accessToken) {
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}

export async function login({ email, password }) {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    // refresh token is set as an HttpOnly cookie by the server
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });

  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    /* leave data = {} */
  }

  if (!res.ok) {
    // unify error message shape
    const msg = data?.error || `Login failed (${res.status})`;
    throw new Error(msg);
  }

  // Normalize to the session shape your app already uses
  return {
    accessToken: data.access_token, // camelCase for frontend
    user: data.user, // already in expected shape
  };
}

export async function updateMe(patch) {
  const res = await authFetch("/auth/me", {
    method: "PATCH",
    body: JSON.stringify(patch),
  });

  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    /* leave data = {} */
  }

  if (!res.ok) {
    const msg = data?.message || data?.error || `Profile update failed (${res.status})`;
    throw new Error(msg);
  }

  return data;
}
